<template>
  <div>
    <el-container>
      <el-header style="border-bottom: 1px solid #ccc;">
        <myNav></myNav>
      </el-header>
      <el-container class="mainContainer">
        <el-aside width="200px">
          <myMenu active="4" />
        </el-aside>
        <el-main>
          <el-row>
            <el-col :span="24">
              <template>
                <el-table v-loading="tableLoading"
                          :data="pageInfo.records"
                          style="width: 100%">
                  <el-table-column prop="packageName"
                                   label="套餐名称"
                                   width="180">
                  </el-table-column>
                  <el-table-column prop="createTime"
                                   label="创建日期"
                                   width="180">
                  </el-table-column>
                  <el-table-column prop="payFinishTime"
                                   label="支付时间"
                                   width="180">

                  </el-table-column>
                  <el-table-column label="套餐开始时间"
                                   width="180">
                    <template slot-scope="scope">
                      {{scope.row.startTime | timeFilter}}
                    </template>
                  </el-table-column>
                  <el-table-column label="套餐结束时间"
                                   width="180">
                    <template slot-scope="scope">
                      {{scope.row.expireTime | timeFilter}}
                    </template>
                  </el-table-column>
                  <el-table-column label="订单状态">
                    <template slot-scope="scope">
                      {{scope.row.orderStatus | orderStatusFilter}}
                    </template>
                  </el-table-column>

                </el-table>
              </template>

            </el-col>
            <el-col :span="24">
              <br>
              <el-pagination background
                             @current-change="getPageList"
                             layout="prev, pager, next,total"
                             :current-page="pageInfo.current"
                             :page-size="pageInfo.size"
                             :total="pageInfo.total">
              </el-pagination>
            </el-col>
          </el-row>

        </el-main>
      </el-container>
    </el-container>

    <el-dialog width="500"
               top="0"
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl"
              style="width: 100%;
    height: calc(100vh - 120px);
    border: 0;" />
      <el-button @click="toDownload(sourceId)"
                 size="small">下载</el-button>
    </el-dialog>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import axios from 'axios'
// import dateFormat from 'dateformat'
import moment from 'moment'
import myNav from '../components/nav'
import myMenu from '../components/menu'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      pdfDialogVisible: false,
      pdfUrl: '',
      sourceId: ''
    }
  },
  filters: {
    orderStatusFilter: function (v) {
      switch (v) {
        case 'FINISH':
          return '已完成'
        case 'CANCEL':
          return '已取消'
        case 'WAITING':
          return '待支付'
        case 'FAIL':
          return '支付失败'

        default:
          return v
      }
    },
    timeFilter: function (v) {
      // return dateFormat(new Date(v), 'yyyy-mm-dd HH:MM:ss')
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    getPageList (val) {
      let _this = this
      axios.get('/api/web/order/list?page=' + val + '&pageSize=' + this.pageInfo.size).then(resp => {
        _this.pageInfo = resp.data
        _this.pageInfo.current = parseInt(resp.data.current)
        _this.pageInfo.total = parseInt(resp.data.total)
        _this.pageInfo.size = parseInt(resp.data.size)
        _this.tableLoading = false
      })
    }
  },
  components: {
    myNav, myMenu, Dropzone
  },
  mounted () {
    this.getPageList(1)
  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/orders.vue